<section id="process" class="process-section section-padding">
  <div class="container">
    
    <!-- Section Header -->
    <div class="section-header reveal-on-scroll">
      <span class="subtitle">STEP-BY-STEP PROCESS</span>
      <h2 class="title">YOUR BUILDING JOURNEY</h2>
      <div class="gold-divider"></div>
      <p class="description">
        We guide you seamlessly from early concepts through to turning the key on your new home.
      </p>
    </div>

    <!-- Timeline Stepper Bar -->
    <div class="timeline-wrapper reveal-scale">
      <div class="timeline-line"></div>

      <div class="timeline-nodes">
        @for (step of journeySteps(); track step.stepNumber; let i = $index) {
          <div 
            class="timeline-node reveal-on-scroll" 
            [class]="'delay-' + (i + 1)"
            [class.active]="activeStep().stepNumber === step.stepNumber"
            (click)="selectStep(step)">
            <div class="node-circle">0{{ step.stepNumber }}</div>
            <div class="node-title">{{ step.title }}</div>
          </div>
        }
      </div>
    </div>

    <!-- Active Step Detail Panel -->
    <div class="step-detail-card reveal-on-scroll delay-2">
      <div class="step-card-header">
        <div class="header-top-row">
          <div class="step-badge">
            <span>PHASE 0{{ activeStep().stepNumber }} / 05</span>
            <span class="dot">•</span>
            <span>DURATION: {{ activeStep().duration }}</span>
          </div>

          <!-- Step Nav Controls -->
          <div class="step-nav-buttons">
            <button 
              (click)="prevStep()" 
              [disabled]="activeStep().stepNumber === 1" 
              class="step-arrow-btn" 
              aria-label="Previous Step">
              &larr; PREV
            </button>
            <button 
              (click)="nextStep()" 
              [disabled]="activeStep().stepNumber === journeySteps().length" 
              class="step-arrow-btn gold" 
              aria-label="Next Step">
              NEXT &rarr;
            </button>
          </div>
        </div>

        <h3 class="step-heading">{{ activeStep().title }}</h3>
      </div>

      <div class="step-card-body">
        <p class="step-desc">{{ activeStep().detailDesc }}</p>

        <div class="deliverables-title">WHAT HAPPENS IN THIS STAGE:</div>
        <div class="deliverables-grid">
          @for (item of activeStep().keyDeliverables; track item) {
            <div class="deliv-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <span>{{ item }}</span>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="process-cta-wrap reveal-on-scroll delay-3">
      <button (click)="talkToTeam()" class="btn-gold">
        TALK TO OUR TEAM &rarr;
      </button>
    </div>

  </div>
</section>
